import React from "react";
import { Clock, Flame, Wrench } from "lucide-react";

export default function StoreStatusBanner({ store }) {
  if (!store) return null;
  const open = store.is_open;
  const preview = store.preview_mode;
  return (
    <div
      className={`w-full border-b ${preview ? "bg-amber-700/20 border-amber-500/50" : open ? "bg-green-700/15 border-green-500/40" : "bg-accent/15 border-accent/50"}`}
      data-testid="store-status-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm">
        <span
          className={`inline-flex items-center gap-2 font-heading uppercase tracking-widest ${preview ? "text-amber-300" : open ? "text-green-300" : "text-accent"}`}
        >
          {preview ? <Wrench className="h-4 w-4" /> : open ? <Flame className="h-4 w-4" /> : <Clock className="h-4 w-4" />}
          {preview ? "Preview Mode — Always Open for Testing" : open ? "Open Now — Taking Orders" : "Currently Closed"}
        </span>
        <span className="text-cream/60">·</span>
        <span className="text-cream/80">
          Live hours: {store.hours_label} · {store.open_days.join(", ")}
        </span>
        {!preview && !open && store.next_open_label && (
          <>
            <span className="text-cream/60">·</span>
            <span className="text-gold font-heading uppercase tracking-widest text-xs" data-testid="next-open-label">
              Re-opens {store.next_open_label}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
